exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".textareaContacts {\n  height: 141px;\n}\n", ""]);

// exports
